import React from 'react';
import { Checkbox, CheckboxProps, FormControlLabel, FormControlLabelProps, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export type WcnCheckboxProps = Omit<CheckboxProps, 'icon' | 'checkedIcon'> & {
    label?: React.ReactNode;
    labelPlacement?: FormControlLabelProps['labelPlacement'];
    labelSx?: SxProps<Theme>;
};

const WcnCheckbox: React.FC<WcnCheckboxProps> = ({ size = 'medium', label, labelPlacement, labelSx, ...props }) => {
    const sizeClass = `wcn-checkbox__icon--${size}`;
    const checkbox = (
        <Checkbox
            {...props}
            size={size}
            className={`wcn-checkbox ${props.className ?? ''}`}
            icon={<i className={`bi bi-square wcn-checkbox__icon-outline ${sizeClass}`} />}
            checkedIcon={<i className={`bi bi-check-square-fill wcn-checkbox__icon-checked ${sizeClass}`} />}
        />
    );

    if (label !== undefined) {
        return <FormControlLabel control={checkbox} label={label} labelPlacement={labelPlacement} sx={labelSx} />;
    }

    return checkbox;
};

export default WcnCheckbox;
